import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';

const Podcast = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <section 
        className="py-20 px-6 text-white relative overflow-hidden"
        style={{ backgroundColor: '#b76e79' }}
      >
        <div className="max-w-6xl mx-auto text-center relative z-10">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            Our Podcast
          </h1>
          <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed">
            Tune in for authentic conversations, inspiring stories, and bold discussions 
            about the Latina experience. New episodes every week!
          </p>
        </div>
      </section>

      {/* Podcast Player */}
      <section className="py-16 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="mb-8">
            <h2 className="text-3xl font-bold mb-2">Listen to Our Episodes</h2>
            <p className="text-gray-600">
              Join amigas Jatnna and Rosibel as they share real conversations about being 
              millennial Latinas and working mamis
            </p>
          </div>

          {/* Buzzsprout Player */}
          <Card className="border-none shadow-xl mb-12">
            <CardContent className="p-6">
              <iframe 
                id="player_iframe" 
                src="https://www.buzzsprout.com/826129?client_source=large_player&iframe=true&referrer=https%3A%2F%2Fwww.buzzsprout.com%2Fadmin%2F826129%2Fpodcast%2Fembed" 
                loading="lazy" 
                width="100%" 
                height="375" 
                frameBorder="0" 
                scrolling="no" 
                title="Dos Bold Latinas"
                className="rounded-lg"
              />
            </CardContent>
          </Card>

          {/* Subscribe CTA */}
          <Card className="bg-gradient-to-r from-gray-900 to-gray-800 text-white border-none">
            <CardContent className="p-12 text-center">
              <h3 className="text-3xl font-bold mb-4">
                Never Miss an Episode
              </h3>
              <p className="text-gray-300 mb-8 text-lg max-w-2xl mx-auto">
                Subscribe to our podcast on your favorite platform and get notified 
                when new episodes drop!
              </p>
              <div className="flex flex-wrap gap-4 justify-center">
                <a 
                  href="https://podcasts.apple.com/us/podcast/dos-bold-latinas/id1495602509" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <Button 
                    size="lg"
                    className="text-lg px-8 py-6"
                    style={{ backgroundColor: '#b76e79' }}
                  >
                    Apple Podcasts
                  </Button>
                </a>
                <a 
                  href="https://open.spotify.com/show/5ajkirPRCHVOfyAQVCHuIj?si=371c471cd58b410f" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <Button 
                    size="lg"
                    variant="outline"
                    className="text-lg px-8 py-6 bg-white/10 text-white border-white hover:bg-white hover:text-black"
                  >
                    Spotify
                  </Button>
                </a>
                <a 
                  href="https://www.buzzsprout.com/826129" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <Button 
                    size="lg"
                    variant="outline"
                    className="text-lg px-8 py-6 bg-white/10 text-white border-white hover:bg-white hover:text-black"
                  >
                    Buzzsprout
                  </Button>
                </a>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default Podcast;